import * as React from 'react'
import { ReactElement } from 'react'
import { FileSuggestionMatchDto } from './FileMessageForm'
import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow,
    TableCellLayout,
    TableColumnDefinition,
} from '@fluentui/react-components'
import { DataPromise } from '../../context/AxiosContext'
import { useTranslation } from 'react-i18next'

const getColumns = (translate: (key: string) => string): TableColumnDefinition<FileSuggestionMatchDto>[] => [
    createTableColumn<FileSuggestionMatchDto>({
        columnId: 'reference',
        compare: (a, b) => {
            return a.reference.localeCompare(b.reference)
        },
        renderHeaderCell: () => translate('base.table.header.number'),
        renderCell: item => {
            return <TableCellLayout>{item.reference}</TableCellLayout>
        },
    }),
    createTableColumn<FileSuggestionMatchDto>({
        columnId: 'name',
        compare: (a, b) => {
            return a.name.localeCompare(b.name)
        },
        renderHeaderCell: () => translate('base.table.header.name'),
        renderCell: item => {
            return <TableCellLayout>{item.name}</TableCellLayout>
        },
    }),
]

const columnSizingOptions = {
    reference: {
        minWidth: 80,
        defaultWidth: 80,
    },
}

export default function FileSuggestionDataGrid(props: {
    suggestions: DataPromise<FileSuggestionMatchDto[]>
    selectedItems: string[]
    onSelectionChange: (references: string[]) => void
}): ReactElement {
    const { t: translate } = useTranslation()

    if (props.suggestions.loading || (props.suggestions.loaded && props.suggestions.data.length === 0)) {
        return <></>
    }

    return (
        <DataGrid
            items={props.suggestions.data.slice(0, 6)}
            columns={getColumns(translate)}
            resizableColumns
            columnSizingOptions={columnSizingOptions}
            sortable
            selectionMode="multiselect"
            selectedItems={props.selectedItems}
            onSelectionChange={(_, data) => props.onSelectionChange([...data.selectedItems] as string[])}
            getRowId={item => item.reference}
            focusMode="composite"
        >
            <DataGridHeader>
                <DataGridRow>{({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}</DataGridRow>
            </DataGridHeader>
            <DataGridBody<FileSuggestionMatchDto>>
                {({ item, rowId }) => (
                    <DataGridRow<FileSuggestionMatchDto> key={rowId}>
                        {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
    )
}
